/**
 * Creates a function that checks if a given value matches the specified attribute.
 *
 * @template T
 * @param {T} attr - The attribute to compare against.
 * @returns {(value: T) => boolean} A function that takes a value and returns `true` if it matches the attribute, otherwise `false`.
 */
const checkValue = (attr) => {
  return (value) => { return attr === value };
};

export const checkTrue = checkValue(true);
export const checkFalse = checkValue(false);